/**
 * In-card reel playback for Essential / Explore / Deep Dive stories.
 * Scoped to [data-pwz-reel-play]. Theme Editor safe via event delegation.
 */
(function () {
  if (window.__pwzProductReelsInit) return;
  window.__pwzProductReelsInit = true;

  function reelRoot(from) {
    return from && from.closest ? from.closest(".reels-row, .stories-section, .pw-experience-cards") : null;
  }

  function stopReelPlayers(scope, exceptCard) {
    if (!scope) return;
    scope.querySelectorAll(".reel-card.is-playing").forEach(function (card) {
      if (card === exceptCard) return;
      card.classList.remove("is-playing");
      var video = card.querySelector(".reel-native");
      if (video) {
        video.pause();
        try {
          video.currentTime = 0;
        } catch (error) {}
      }
      var iframe = card.querySelector(".reel-embed");
      if (iframe) iframe.remove();
      var play = card.querySelector("[data-pwz-reel-play]");
      if (play) {
        play.hidden = false;
        play.removeAttribute("aria-hidden");
      }
    });
  }

  function coverReelEmbed(iframe, card) {
    if (!iframe || !card) return;
    var media = card.querySelector("[data-pwz-reel-media]");
    var rect = (media || card).getBoundingClientRect();
    var cardW = rect.width;
    var cardH = rect.height;
    if (!cardW || !cardH) return;

    var isShorts = card.classList.contains("is-shorts");
    var ratioW = isShorts ? 9 : 16;
    var ratioH = isShorts ? 16 : 9;
    var videoRatio = ratioW / ratioH;
    var iframeW;
    var iframeH;

    if (cardW / cardH > videoRatio) {
      iframeW = cardW;
      iframeH = cardW / videoRatio;
    } else {
      iframeH = cardH;
      iframeW = cardH * videoRatio;
    }

    var scale = isShorts ? 1.28 : 1.18;
    iframeW = Math.ceil(iframeW * scale);
    iframeH = Math.ceil(iframeH * scale);

    iframe.setAttribute("width", String(iframeW));
    iframe.setAttribute("height", String(iframeH));
    iframe.style.width = iframeW + "px";
    iframe.style.height = iframeH + "px";
    iframe.style.top = "50%";
    iframe.style.left = "50%";
    iframe.style.transform = "translate(-50%, -50%)";
  }

  function resizePlayingReels() {
    document.querySelectorAll(".reel-card.is-playing .reel-embed").forEach(function (iframe) {
      coverReelEmbed(iframe, iframe.closest(".reel-card"));
    });
  }

  function playReelCard(button) {
    var card = button.closest(".reel-card");
    var media = card && card.querySelector("[data-pwz-reel-media]");
    if (!card || !media || card.classList.contains("is-playing")) return;

    stopReelPlayers(reelRoot(card), card);

    var type = button.getAttribute("data-video-type");
    if (type === "shopify") {
      var video = media.querySelector(".reel-native");
      if (!video) return;
      video.setAttribute("playsinline", "");
      video.setAttribute("webkit-playsinline", "");
      video.playsInline = true;
      card.classList.add("is-playing");
      button.hidden = true;
      button.setAttribute("aria-hidden", "true");
      var playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
      return;
    }

    var embedUrl = button.getAttribute("data-embed-url");
    if (!embedUrl) return;

    var iframe = document.createElement("iframe");
    iframe.className = "reel-embed";
    iframe.src = embedUrl;
    iframe.setAttribute("allow", "autoplay; encrypted-media; picture-in-picture");
    iframe.setAttribute("allowfullscreen", "true");
    iframe.setAttribute("loading", "lazy");
    iframe.setAttribute("referrerpolicy", "strict-origin-when-cross-origin");
    iframe.setAttribute("title", button.getAttribute("data-iframe-title") || "Video");
    iframe.setAttribute("playsinline", "");
    media.appendChild(iframe);
    coverReelEmbed(iframe, card);
    card.classList.add("is-playing");
    button.hidden = true;
    button.setAttribute("aria-hidden", "true");
  }

  document.addEventListener("click", function (event) {
    var play = event.target.closest("[data-pwz-reel-play]");
    if (!play) return;
    event.preventDefault();
    event.stopPropagation();
    playReelCard(play);
  });

  document.addEventListener(
    "error",
    function (event) {
      var img = event.target;
      if (!img || img.tagName !== "IMG") return;
      var fallback = img.getAttribute("data-yt-fallback");
      if (!fallback || img.src === fallback) return;
      img.src = fallback;
      img.removeAttribute("data-yt-fallback");
      var card = img.closest(".reel-card");
      if (card && !card.classList.contains("is-shorts-poster-crop")) {
        card.style.backgroundImage = "url('" + fallback + "')";
        card.style.backgroundSize = "cover";
        card.style.backgroundPosition = "center";
      }
    },
    true
  );

  window.addEventListener("resize", resizePlayingReels);
  document.addEventListener("shopify:section:unload", function (event) {
    stopReelPlayers(event.target);
  });
})();
